import { Buffer } from 'buffer';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx'
import axios from 'axios'
import { toastShow } from './ToastService';

export const ArchivosExcelService = (csvData, fileName) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);

}

export const ArchivoConvertSQL = async (file, setResult) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = function (event) {
        setResult(Buffer.from(reader.result));
    }
}

export const downloadBase64Data = (file) => {
    let filename = file.Tipo
    var binary = '';
    var bytes = [].slice.call(new Uint8Array(file.Data.data));
    bytes.forEach((b) => binary += String.fromCharCode(b));
    const base64String = window.btoa(binary);
    // console.log(base64String)
    let tipoExtension = filename.split(".").pop();
    let linkSource = ''
    switch ((tipoExtension.toLowerCase())) {
        case "pdf":
            linkSource = `data:application/pdf;base64,${base64String}`;
            break;
        case "xlsx":
            linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
            break;
        case "xls":
            linkSource = `data:application/vnd.ms-excel;base64,${base64String}`;
            break;
        case 'doc':
            linkSource = `data:application/msword;base64,${base64String}`;
            break;
        case 'docx':
            linkSource = `data:application/msword;base64,${base64String}`;
            break;
        case 'ppt':
            linkSource = `data:application/	application/vnd.ms-powerpoint;base64,${base64String}`;
            break;
        case 'bz':
            linkSource = `data:application/x-bzip;base64,${base64String}`;
            break;
        case 'bz2':
            linkSource = `data:application/x-bzip2;base64,${base64String}`;
            break;
        case 'csv':
            linkSource = `data:text/csv;base64,${base64String}`;
            break;
        case 'epub':
            linkSource = `data:	application/epub+zip;base64,${base64String}`;
            break;
        case "gif":
            linkSource = `data:	image/gif;base64,${base64String}`;
            break;
        case "png":
            linkSource = `data:image/png;base64,${base64String}`;
            break;
        case "jpeg":
            linkSource = `data:image/jpeg;base64,${base64String}`;
            break;
        case "jpg":
            linkSource = `data:image/jpeg;base64,${base64String}`;
            break;
        case "ico":
            linkSource = `data:image/x-icon;base64,${base64String}`;
            break;
        case "txt":
            linkSource = `data:text/plain;base64,${base64String}`;
            break;
        case "json":
            linkSource = `data:application/json;base64,${base64String}`;
            break;
        case 'zip':
            linkSource = `data:application/zip;base64,${base64String}`;
            break;
        case 'rar':
            linkSource = `data:application/x-rar-compressed;base64,${base64String}`;
            break;
        case 'tar':
            linkSource = `data:application/x-tar;base64,${base64String}`;
            break;
        case '7z':
            linkSource = `data:application/x-7z-compressed;base64,${base64String}`;
            break;

        default:
            linkSource = `data:text/plain;base64,${base64String}`;
            break;
    }

    const downloadLink = document.createElement('a');
    const fileName = filename;
    descargarArchivo(linkSource, downloadLink, fileName)

}

const descargarArchivo = (linkSource, downloadLink, fileName) => {
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}


export const exportarExcel = ({ Data, Columns }, name) => {
    // console.log(Data, Columns)
    const t = Data.map(i => {
        let data = {}
        Columns.forEach(col => {
            data[col.header] = i[col.field]
        })
        return data;
    })
    ArchivosExcelService(t, name)
}


export const uploadHandler = ({ e, inputs, toast, ref, url, getArchivos = () => {}  }) => {
    const maxFileSize = 5 * 1024 * 1024; 
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];
    
        if (file.size > maxFileSize) {
            if (toast) {
                toastShow(toast, 'error', `El Archivo excede el límite de tamaño (5MB)`);
            }
            continue;
        }

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        // console.log(formData.get('file'));
        axios.post(`${process.env.REACT_APP_API_URL}/IT/Archivos/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken),
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}


const getFileExtension = (filename) => {
    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex !== -1) {
        return filename.substring(dotIndex + 1).toLowerCase();
    }
    return ''; 
};


export const uploadHandlerImg = ({ e, inputs, toast, ref, url, getArchivos = () => {}   }) => {
    const maxFileSize = 5 * 1024 * 1024; 
    const maxFiles = 3; 
    const acceptedFileExtensions = ['jpg', 'jpeg', 'png'];
    // console.log(e.files[0].name)
    const fileExtension = getFileExtension(e.files[0].name);

    if (!acceptedFileExtensions.includes(fileExtension.toLowerCase())) {
        toastShow(toast, 'error', 'Solo se permiten subir Imágenes');
    }
    if (e.files.length > maxFiles) {
        if (toast) {
            toastShow(toast, 'error', 'Solo se permiten subir hasta 3 archivos.');
        }
        return; 
    }

    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];
    
        if (file.size > maxFileSize) {
            if (toast) {
                toastShow(toast, 'error', `La Imagen excede el límite de tamaño (5MB)`);
            }
            continue;
        }

        var formData = new FormData();
        formData.append('file', file);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        });

        // console.log(formData.get('file'));
        axios.post(`${process.env.REACT_APP_API_URL}/IT/Imagenes/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken),
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}


export const downloadFile = async (bufferData, nombreArchivo) => {
    // Crear un Uint8Array directamente desde el array de datos
  const uint8Array = new Uint8Array(bufferData.data);

  // Crear un Blob a partir del Uint8Array
  const blob = new Blob([uint8Array], { type: 'application/octet-stream' });

  // Crear un objeto URL para el Blob
  const url = window.URL.createObjectURL(blob);

  // Crear un enlace de descarga
  const enlaceDescarga = document.createElement('a');
  enlaceDescarga.href = url;
  enlaceDescarga.setAttribute('download', nombreArchivo);

  // Agregar el enlace al DOM y simular un clic
  document.body.appendChild(enlaceDescarga);
  enlaceDescarga.click();

  // Limpiar el objeto URL y eliminar el enlace del DOM
  window.URL.revokeObjectURL(url);
  document.body.removeChild(enlaceDescarga);
}

export const uploadHandlerFirma = ({ e, inputs, toast, ref, url, getArchivos = () => {} , Token  }) => {
    const maxFileSize = 5 * 1024 * 1024; 
    const maxFiles = 3; 
    const acceptedFileExtensions = ['jpg', 'jpeg', 'png'];
    // console.log(e.files[0].name)
    const fileExtension = getFileExtension(e.files[0].name);

    if (!acceptedFileExtensions.includes(fileExtension.toLowerCase())) {
        toastShow(toast, 'error', 'Error', 'Solo se permiten subir Imágenes');
    }
    if (e.files.length > maxFiles) {
        if (toast) {
            toastShow(toast, 'error', 'Error', 'Solo se permite subir 1 Firma.');
        }
        return; 
    }

    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];
    
        if (file.size > maxFileSize) {
            if (toast) {
                toastShow(toast, 'error', 'Error', `La Imágen excede el límite de tamaño (5MB)`);
            }
            continue;
        }

        var formData = new FormData();
        formData.append('file', file);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        });

        // console.log(formData.get('file'));
        axios.post(`${process.env.REACT_APP_API_URL}/IT/Users/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success','Agregada','Firma Agregada')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error', 'Error al subir la firma')
            }
        })
    }
}

export const uploadHandlerFoto = ({ e, inputs, toast, ref, url, getArchivos = () => {} , Token  }) => {
    const maxFileSize = 5 * 1024 * 1024; 
    const maxFiles = 3; 
    const acceptedFileExtensions = ['jpg', 'jpeg', 'png'];
    // console.log(e.files[0].name)
    const fileExtension = getFileExtension(e.files[0].name);

    if (!acceptedFileExtensions.includes(fileExtension.toLowerCase())) {
        toastShow(toast, 'error', 'Error', 'Solo se permiten subir Imágenes');
    }
    if (e.files.length > maxFiles) {
        if (toast) {
            toastShow(toast, 'error', 'Error', 'Solo se permite subir 1 Firma.');
        }
        return; 
    }

    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];
    
        if (file.size > maxFileSize) {
            if (toast) {
                toastShow(toast, 'error', 'Error', `La Imágen excede el límite de tamaño (5MB)`);
            }
            continue;
        }

        var formData = new FormData();
        formData.append('file', file);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        });

        // console.log(formData.get('file'));
        axios.post(`${process.env.REACT_APP_API_URL}/IT/Users/upload/Foto?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Guardada','Imágen agregada correctamente')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error','Error', 'Error al subir la imágen')
            }
        })
    }
}


// ------------------------------------------------PROVEEDORES-------------------------------------------------------------

export const uploadHandlerBICProveedores = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Compras/Proveedores/BIC/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Agregada', 'Imágen agregado correctamente')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerFacturaProveedores = ({ e, inputs, toast, ref, url, getArchivos = () => {}  , Token}) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Compras/Proveedores/Factura/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),
                
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerPermisoProveedores = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Compras/Proveedores/Permiso/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerEscrituraProveedores = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Compras/Proveedores/Escritura/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerConstanciaProveedores = ({ e, inputs, toast, ref, url, getArchivos = () => {}  , Token}) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Compras/Proveedores/Constancia/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerRegistroProveedores = ({ e, inputs, toast, ref, url, getArchivos = () => {} , Token }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Compras/Proveedores/Registro/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerFormatoProveedores = ({ e, inputs, toast, ref, url, getArchivos = () => {} , Token }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Compras/Proveedores/Formato/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}


// ------------------------------------------------CLIENTES-------------------------------------------------------------------

export const uploadHandlerBIC = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Clientes/BIC/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerFactura = ({ e, inputs, toast, ref, url, getArchivos = () => {}  , Token}) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Clientes/Factura/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),
                
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerPermiso = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Clientes/Permiso/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerEscritura = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Clientes/Escritura/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerConstancia = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Clientes/Constancia/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerRegistro = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Clientes/Registro/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerEstados = ({ e, inputs, toast, ref, url, getArchivos = () => {}, Token  }) => {
    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', e.files[i]);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        })

        axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Clientes/Estados/upload?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': Token ? Token : localStorage.getItem(process.env.REACT_APP_StorageToken),

            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerFotoCandidato = ({ e, inputs, toast, ref, url, getArchivos = () => {}   }) => {
    const maxFileSize = 5 * 1024 * 1024; 
    const maxFiles = 3; 
    const acceptedFileExtensions = ['jpg', 'jpeg', 'png'];
    // console.log(e.files[0].name)
    const fileExtension = getFileExtension(e.files[0].name);

    if (!acceptedFileExtensions.includes(fileExtension.toLowerCase())) {
        toastShow(toast, 'error', 'Error', 'Solo se permiten subir Imágenes');
    }
    if (e.files.length > maxFiles) {
        if (toast) {
            toastShow(toast, 'error', 'Error', 'Solo se permiten subir hasta 3 archivos.');
        }
        return; 
    }

    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];
    
        if (file.size > maxFileSize) {
            if (toast) {
                toastShow(toast, 'error', 'Error', `La Imagen excede el límite de tamaño (5MB)`);
            }
            continue;
        }

        var formData = new FormData();
        formData.append('file', file);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        });

        // console.log(formData.get('file'));
        axios.post(`${process.env.REACT_APP_API_URL}/Payrolls/Maestros/AgregarFoto?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken),
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

export const uploadHandlerHVI = ({ e, inputs, toast, ref, url, getArchivos = () => {}   }) => {

    for (let i = 0; i < e.files.length; i++) {
        const file = e.files[i];

        var formData = new FormData();
        formData.append('file', file);

        inputs.forEach(input => {
            formData.append(input.name, input.value);
        });
        axios.post(`${process.env.REACT_APP_API_URL}/Payrolls/Maestros/AgregarHVI?${Date.now()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken),
            }
        }).then(res => {
            if (toast) {
                toastShow(toast, 'success', 'Archivo Agregado')
            }
            ref.current.clear();
            getArchivos()
        }).catch(err => {
            if (toast) {
                toastShow(toast, 'error', 'Error al subir el archivo')
            }
        })
    }
}

// Función para convertir un archivo Excel a JSON
export const getDataArchivoToJson = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
 
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
 
 
            const result = {};
            workbook.SheetNames.forEach((sheetName) => {
                const sheet = workbook.Sheets[sheetName];
                const sheetData = XLSX.utils.sheet_to_json(sheet, {
                    header: 1,
                    defval: "",
                    blankrows: false
                });
 
                const headers = sheetData[0];
                const rows = sheetData.slice(1);
 
                const formattedData = rows.map(row => {
                    const rowData = {};
                    headers.forEach((header, index) => {
                        rowData[header || `Columna_${index + 1}`] = row[index];
                    });
                    return rowData;
                });
 
                result[sheetName] = formattedData;
            });
 
            resolve(result);
        };
 
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
}